<app-page-heading [title]="'Drivers'"></app-page-heading>

<section class="container-fluid summary-panel">

    <div class="m-t-sm">
        <div class="col-xs-4 top-bar-element">
            <app-data-filters #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'Enter at least three characters'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>
        </div>
        <div class="col-xs-4 top-bar-element pull-right">
            <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateDriver()">
                <span class="fa fa-plus"></span> Create Driver
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table [loadPage]="loadPage"
                                    [showSubcontractor]="true"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (edit)="goToEditDriver($event)"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
